import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgVisibilityHidden = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.76762 4.85355C2.57235 5.04882 2.57235 5.3654 2.76762 5.56066L17.6169 20.4099C17.8121 20.6052 18.1287 20.6052 18.324 20.4099L19.0311 19.7028C19.2263 19.5075 19.2263 19.191 19.0311 18.9957L17.1394 17.104C17.7035 16.7868 18.2192 16.4322 18.6853 16.0607C20.3102 14.766 21.3969 13.2214 21.9142 12.1588C22.0288 11.9237 22.0288 11.6618 21.9142 11.4267C21.3969 10.3642 20.3102 8.81656 18.6853 7.52488C17.05 6.2213 14.8037 5.12605 11.9983 5.12605C9.88946 5.12605 8.09646 5.74499 6.64148 6.6061L4.18183 4.14645C3.98657 3.95118 3.66998 3.95118 3.47472 4.14645L2.76762 4.85355ZM8.42563 8.39024L10.5714 10.536C11.4067 10.2165 11.9999 9.4074 11.9999 8.45977C13.8408 8.45977 15.3332 9.95216 15.3332 11.7931C15.3332 12.7572 14.9239 13.6257 14.2697 14.2343L15.365 15.3296C16.6964 14.5176 17.5557 13.2355 17.5557 11.7928C17.5557 9.33815 15.0684 7.34829 12.0001 7.34829C10.6387 7.34829 9.39174 7.74001 8.42563 8.39024Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M2.08593 11.4267C2.38802 10.802 2.88811 10.0097 3.57915 9.20032L6.45564 12.0768C6.60505 13.972 8.23915 15.5448 10.438 16.0592L12.8076 18.4287C12.5432 18.449 12.2735 18.4595 11.9983 18.4595C9.19301 18.4595 6.94666 17.3642 5.31137 16.0607C3.6865 14.769 2.59978 13.2214 2.08593 12.1588C1.97136 11.9237 1.97136 11.6618 2.08593 11.4267Z", fill: props.fill }));
});
export default SvgVisibilityHidden;
